import { useState, useEffect } from 'react';

const WHATSAPP_LINK = 'https://wa.me/5521974393072?text=Ol%C3%A1!%20Gostaria%20de%20uma%20consulta%20jur%C3%ADdica.';
const LOGO_URL = 'https://storage.readdy-site.link/project_files/d8bcc27c-0b18-4a10-81b7-54a88326e269/eef687c5-6cb0-41fa-90b8-160538453ebf_LOGO-1---Dbora-Martins-Photoroom.png?v=89cba24b9a9a6a7ad6cf718733ec20fb';

const NAV_LINKS = [
  { label: 'Sobre', href: '#sobre' },
  { label: 'Áreas de Atuação', href: '#areas' },
  { label: 'Como Atuamos', href: '#como-atuamos' },
  { label: 'Contato', href: '#contato' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-marrom-escuro shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        {/* Logo */}
        <a href="/" className="flex items-center gap-3 cursor-pointer">
          <div className="w-[92px] h-[92px] flex items-center justify-center overflow-visible">
            <img
              src={LOGO_URL}
              alt="Carvalho e França Advogadas"
              className="w-full h-full object-contain scale-[1.40]"
            />
          </div>
        </a>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="font-sans text-sm text-white/80 hover:text-dourado-principal transition-colors duration-300 tracking-wide cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* CTA + Mobile Menu */}
        <div className="flex items-center gap-4">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="nofollow noreferrer"
            className="hidden sm:flex items-center gap-2 bg-dourado-principal hover:bg-dourado-medio text-marrom-escuro font-sans font-bold text-sm px-5 py-2.5 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-line text-base" />
            </div>
            Falar no WhatsApp
          </a>

          {/* Mobile toggle */}
          <button
            className="lg:hidden w-8 h-8 flex items-center justify-center text-white cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl`} />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-marrom-escuro border-t border-dourado-principal/20 px-6 pb-6">
          {NAV_LINKS.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="block w-full text-left font-sans text-white/80 hover:text-dourado-principal py-3 text-sm border-b border-white/10 cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="nofollow noreferrer"
            className="mt-4 flex items-center justify-center gap-2 bg-dourado-principal text-marrom-escuro font-sans font-bold text-sm px-5 py-3 rounded-md cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-line text-base" />
            </div>
            Falar no WhatsApp
          </a>
        </div>
      )}
    </header>
  );
}
